import utils from "../common/util";
import cmpPageHeader from "./cmp-page-header";

const cmpImageAttributionGallery = {
	component: null,

	init: function (element)
	{
		utils.log('cmpImageAttributionGallery initiated : #' + element.id, 'info');

		const _ = utils.setEnvironment(this);
		_.component = element;
		_.thumbnails = document.getElementsByClassName('image-attribution-container__image');
		_.intro = document.getElementById('image-attribution-container__intro');

		_.onClickEvent(_.thumbnails);
	},

	onClickEvent: function (elements)
	{
		const _ = this;

		for (const element of elements) {
			element.addEventListener('click', _.handleThumbnailClick.bind(this));
		}
	},

	handleThumbnailClick: function (event)
	{
		const _ = this;
		let clicked = (event.target);
		let parentDiv = clicked.closest('div.image-attribution-container__image');
		let imageToLoad = null;
		let closeImage = false;

		if(!parentDiv.classList.contains('current'))
		{
			imageToLoad = parentDiv;
		}

		else if(clicked.classList.contains('next-btn'))
		{
			imageToLoad = parentDiv.nextElementSibling || null;
			closeImage = false;
		}

		else if(clicked.classList.contains('previous-btn'))
		{
			imageToLoad = parentDiv.previousElementSibling || null;
			closeImage = false;
		}

		else if(clicked.classList.contains('close-btn'))
		{
			closeImage = true;
		}

		if(imageToLoad && !closeImage)
		{
			cmpPageHeader.hidePageHeader();
			utils.showHideElement(_.intro, 'hide');

			for (const element of _.thumbnails) {
				element.classList.remove('current');
				utils.showHideElement(element, 'hide');

			}
			imageToLoad.classList.add('current');
			utils.showHideElement(imageToLoad, 'show');
		}

		if(closeImage)
		{
			cmpPageHeader.showPageHeader();
			utils.showHideElement(_.intro, 'show');

			for (const element of _.thumbnails) {
				element.classList.remove('current');
				utils.showHideElement(element, 'show');
			}
		}

	}
}

export default cmpImageAttributionGallery;
